import { inject, Pipe, PipeTransform } from "@angular/core";
import { ApplicationContext } from "@vega/application-context";

@Pipe({
    name: "price",
    standalone: true
})
export class PricePipe implements PipeTransform {
    private _applicationContext = inject(ApplicationContext);

    transform(amount: number, currencyCode: string): string {
        const x = amount / 100;
        return x.toLocaleString(this._applicationContext.culture, {
            style: "currency",
            currency: currencyCode.toUpperCase()
        });
    }
}
